// TKP-89 / tasarım s.21 — KVKK ve GDPR modülü Ayarlar ekranı. Sayfa, modül düzeninin (layout) korumasından geçer; ayarların
// kendisini backend yalnız o modülün Uyum Yöneticisine ve organizasyon sahibine verir.
export const kvkk = {
  routes: [{ path: "/kvkk/settings", component: () => import("../module-settings-view"), meta: { rules: [], product: "KVKK" } }],
};

export const gdpr = {
  routes: [{ path: "/gdpr/settings", component: () => import("../module-settings-view"), meta: { rules: [], product: "GDPR" } }],
};
